function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from 'react';
import { domExists } from '@domain-group/fe-helper';
import * as styles from './legacy-sticky-sidebox.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getScrollPos = () => {
  var doc = document.documentElement;
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
};
var getElementTop = element => {
  if (!element) {
    return 0;
  }
  var bodyRect = document.body.getBoundingClientRect();
  var elemRect = element.getBoundingClientRect();
  return elemRect.top - bodyRect.top;
};
var getRefValue = func => ref => domExists() && ref.current ? func(ref.current) : 0;
var getRefTop = getRefValue(getElementTop);
var getRefHeight = getRefValue(element => element.offsetHeight);
var StickySidebox = _ref => {
  var _sideboxRef$current;
  var className = _ref.className,
    sidebarBottom = _ref.sidebarBottom,
    _ref$topEdgeOffset = _ref.topEdgeOffset,
    topEdgeOffset = _ref$topEdgeOffset === void 0 ? 0 : _ref$topEdgeOffset,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSticky = _useState2[0],
    setSticky = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBottom = _useState4[0],
    setBottom = _useState4[1];
  var sideboxRef = useRef(null);
  var sideboxHeightRef = useRef(null);
  var offsetParentHeight = getElementTop((_sideboxRef$current = sideboxRef.current) === null || _sideboxRef$current === void 0 ? void 0 : _sideboxRef$current.offsetParent);
  var getScrollEndHeight = () => getRefTop(sidebarBottom) - getRefHeight(sideboxHeightRef);
  var handleScroll = () => {
    var scrollPos = getScrollPos();
    var stickyTopEdge = scrollPos + topEdgeOffset;
    var shouldBeSticky = getRefTop(sideboxRef) < stickyTopEdge;
    if (isSticky !== shouldBeSticky) {
      setSticky(shouldBeSticky);
    }
    var shouldBeBottom = getScrollEndHeight() < stickyTopEdge;
    if (isBottom !== shouldBeBottom) {
      setBottom(shouldBeBottom);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  });
  var mainStyle = [styles.sidebox, isSticky && styles.sticky(topEdgeOffset), isBottom && styles.bottom(getScrollEndHeight() - offsetParentHeight - 2)];
  return ___EmotionJSX("div", {
    "data-testid": "sticky-sidebox",
    ref: sideboxRef
  }, ___EmotionJSX("div", _extends({
    ref: sideboxHeightRef
  }, className ? {
    className
  } : {}, {
    css: mainStyle
  }), children));
};
export default StickySidebox;